/* eslint-disable import/prefer-default-export */
/**
 * 缺少必要參數或是參數錯誤
 */
export class ParameterError extends Error {
}
